import { createApp, defineAsyncComponent } from 'vue';
import * as Sentry from '@sentry/vue';
import { datadogRum } from '@datadog/browser-rum';
import {
  beforeUnmount as beforeUnmountTooltip,
  create as createToolTip,
  update as updateTooltip,
} from './directives/tooltip.js';
import { beforeUnmount as beforeUnmountPopover, create as createPopover } from './directives/popover.js';
import { mounted as mountedFocus } from './directives/focus.js';
import store from './store/index.js';

require('./bootstrap.js');

if ($('#app').length) {
  const app = createApp({
    mounted() {
      this.initLogoutButton();
    },

    methods: {
      initLogoutButton() {
        document.getElementById('nav-sign-out-button')
          ?.addEventListener('click', (event) => {
            event.preventDefault();
            document.getElementById('logout-form').requestSubmit();
          });
      },
    },
  });

  // Vue Components
  app.component('AnalysesAdminListing', defineAsyncComponent(() => import('./components/analyses/admin/Listing.vue')));
  app.component('BreachAnalysisForm', defineAsyncComponent(() => import('./components/breach-analysis/admin/Form.vue')));
  app.component('DemonstrationsAdminListing', defineAsyncComponent(() => import('./components/demonstrations/admin/Listing.vue')));
  app.component('DomainScanHistory', defineAsyncComponent(() => import('./components/domain-scans/admin/History.vue')));
  app.component('DomainSearch', defineAsyncComponent(() => import('./components/search/View.vue')));
  app.component('ImpersonationsListing', defineAsyncComponent(() => import('./components/impersonations/Listing.vue')));
  app.component('ImpersonationForm', defineAsyncComponent(() => import('./components/impersonations/Form.vue')));
  app.component('OpportunitiesListing', defineAsyncComponent(() => import('./components/opportunities/Listing.vue')));
  app.component('PartnerListing', defineAsyncComponent(() => import('./components/partners/Listing.vue')));
  app.component('ResourceListing', defineAsyncComponent(() => import('./components/resources/Listing.vue')));
  app.component('ResourceView', defineAsyncComponent(() => import('./components/resources/View.vue')));
  app.component('UserListing', defineAsyncComponent(() => import('./components/users/Listing.vue')));
  app.component('VerifyEmailCountDown', defineAsyncComponent(() => import('./components/verification/VerifyEmailCountDown.vue')));
  app.component('ChartDoughnut', defineAsyncComponent(() => import('./components/charts/Doughnut.vue')));
  app.component('ChartPercentageBar', defineAsyncComponent(() => import('./components/charts/PercentageBar.vue')));
  app.component('DealsListing', defineAsyncComponent(() => import('./components/deals/Listing.vue')));
  // Vue Directives
  app.directive('tooltip', {
    created: createToolTip,
    updated: updateTooltip,
    beforeUnmount: beforeUnmountTooltip,
  });
  app.directive('popover', {
    created: createPopover,
    beforeUnmount: beforeUnmountPopover,
  });
  app.directive('focus', {
    mounted: mountedFocus,
  });

  app.use(store);

  app.mount('#app');

  if (process.env.MIX_SENTRY_DSN_PUBLIC) {
    Sentry.init({
      app,
      dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
      release: process.env.MIX_APP_RELEASE,
      sampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE,
      trackComponents: true,
      autoSessionTracking: true,
    });
  }

  if (process.env.MIX_DATADOG_APPLICATION_ID) {
    datadogRum.init({
      applicationId: process.env.MIX_DATADOG_APPLICATION_ID,
      clientToken: process.env.MIX_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'mystique',
      env: 'prod',
      version: process.env.MIX_APP_RELEASE,
      sessionSampleRate: Number(process.env.MIX_DATADOG_SAMPLE_RATE),
      sessionReplaySampleRate: Number(process.env.MIX_DATADOG_SAMPLE_RATE),
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      trackFrustrations: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [process.env.MIX_URL],
      enableExperimentalFeatures: ['clickmap'],
    });

    if (window.ddRumData) {
      datadogRum.setUser({
        uuid: window.ddRumData.u_uuid,
        partner_uuid: window.ddRumData.p_uuid,
      });
    } else {
      datadogRum.clearUser();
    }

    datadogRum.startSessionReplayRecording();
  }
}
